import { Text } from 'platform-components/common';
import React from 'react';

interface Props {
    id: string;
}

export const NewYearModalClassCaption = ({ id }: Props) => {
    return (
        <div className="new-year-modal__class-caption">
            <Text id={id} size={Text.SIZE.L} type={Text.TYPE.MARKDOWN} />
        </div>
    );
};
